export default {
  hint: "With PFREUNDT Load & Go, the entire order process becomes digital for all parties involved.",
  password: "Password",
  signIn: "Sign In",
  email: "E-Mail",
  error: "An error appeared while logging in",
  forcedLogout:
    "You have been logged out because your session has expired. Please log in again.",
};
